<template>
  <div class="event-modal-personal-pass">
    <div class="event-modal-personal-pass__main">
      <InputLabel>
        <template #label>
          {{ $t("common.lastName") }}
        </template>

        <input type="text" :value="user.lastname" name="lastname" disabled />
      </InputLabel>

      <InputLabel>
        <template #label>
          {{ $t("common.firstName") }}
        </template>
        <input type="text" :value="user.name" name="name" disabled />
      </InputLabel>

      <InputLabel>
        <template #label>
          {{ $t("common.middleName") }}
        </template>
        <input
          type="text"
          name="middlename"
          :value="user.middlename"
          disabled
        />
      </InputLabel>

      <InputLabel>
        <template #label>
          {{ $t("common.companyName") }}
        </template>
        <input
          :value="user.company_name"
          data-vv-delay="500"
          type="text"
          :placeholder="$t('event.passes.participant.companyName')"
          name="company_name"
          disabled
        />
      </InputLabel>

      <InputLabel v-if="isVisa">
        <template #label>
          {{ $t("common.birthday") }}
        </template>
        <input
          :value="user.birthday"
          data-vv-delay="500"
          type="text"
          name="birthday"
          disabled
        />
      </InputLabel>

      <InputLabel v-if="isVisa">
        <template #label>
          {{ $t("common.birthplace") }}
        </template>
        <input
          type="text"
          :value="user.birthday_place"
          name="birthday_place"
          disabled
        />
      </InputLabel>
      <InputLabel v-if="isVisa">
        <template #label>
          {{ $t("event.passes.participant.citizenship") }}
        </template>
        <input
          type="text"
          :value="citizenship(user)"
          name="birthday_place"
          disabled
        />
      </InputLabel>

      <Checkbox
        v-if="isVisa"
        class="event-modal-personal-pass__main-checkbox"
        v-model="isVisa"
        disabled
      >
        {{ $t("event.passes.participant.isVisaInvite") }}
      </Checkbox>
    </div>

    <slot name="qr-code" />
  </div>
</template>

<script>
import { i18n } from "@v2/shared/config";
import { Checkbox, InputLabel } from "@v2/shared/ui/components";
export default {
  name: "EventModalPersonalPass",

  components: {
    Checkbox,
    InputLabel
  },

  props: {
    user: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    locale() {
      return i18n.locale;
    },
    isVisa() {
      return this.user.type === "visa";
    }
  },
  methods: {
    citizenship(user) {
      return this.locale === "en"
        ? user.country.name_eng
        : user.country.name_rus;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.event-modal-personal-pass {
  &__main {
    max-width: 700px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 20px;
    align-items: end;
    &-checkbox {
      width: max-content;
      margin-bottom: 15px;
    }
  }
}
</style>
